import {
  ADD_PRODUCT,
  EDIT_PRODUCT,
  DELETE_PRODUCT,
  GET_PRODUCT
} from './newproduct.type';

const initialState = {
  products: [],
  productLength: 0,
  isLoaded: false,
}

export default function (state = initialState, action) {
  const { products } = state;
  const copy = [...products];
  const { payload, type } = action;

  switch (type) {

    case GET_PRODUCT:
      return {
        ...state,
        products: payload.products,
        productLength: payload.productLength
      }
    case ADD_PRODUCT:
      const newProducts = [...payload.newProduct, ...state.products];
      if (newProducts.length > 10) {
        newProducts.length = 10;
      }
      console.log(newProducts);
      return {
        ...state,
        products: newProducts
      }
    case EDIT_PRODUCT:
      let index = products.findIndex(data => data.id === payload.id);
      copy[index] = payload.updatedProduct;
      return {
        ...state,
        products: copy
      }
    case DELETE_PRODUCT:
      let i = products.findIndex(data => data.id === payload.id);
      copy.splice(i,1);
      return {
        ...state,
        products: copy
      }
    default:
      return state;

  }

}